import { Fragment, useEffect } from "react";
import { IconButton, Tooltip } from "@material-ui/core";

import AddRoundedIcon from "@material-ui/icons/AddRounded";
import EliminarBoton from "./EliminarBoton";
import EliminarModulo from "./EliminarModulo";
import EliminarSubmodulo from "./EliminarSubmodulo";
import FormBoton from "./FormBoton";
import FormModulo from "./FormModulo";
import FormSubmodulo from "./FormSubmodulo";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import Modulo from "./Modulo";
import RefreshIcon from "@material-ui/icons/Refresh";
import Simbologia from "./Simbologia";
import { useLogin } from "../../../../context/LoginContext";
import { useSistema } from "../../../../context/SistemaContext";

export default function Sistema() {
    const { listaSistemaModulos, handleClickNuevoModulo, handleClickRefrescarDatos } = useSistema();
    const { usuarioPermisos } = useLogin();
    const permisos = usuarioPermisos["1"].Submodulos["3"];

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] !== undefined && ( //Agregar un nuevo módulo
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevoModulo}>
                            <AddRoundedIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] !== undefined && ( //Actualizar información del sistema
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                {listaSistemaModulos.length > 0 ? (
                    listaSistemaModulos.map((modulo) => (
                        <Modulo key={modulo.iIdModulo} modulo={modulo}>
                            modulo
                        </Modulo>
                    ))
                ) : (
                    <div className="center">(No hay módulos configurados)</div>
                )}
            </MeditocBody>
            <Simbologia />
            <FormModulo />
            <EliminarModulo />
            <FormSubmodulo />
            <EliminarSubmodulo />
            <FormBoton />
            <EliminarBoton />
        </Fragment>
    );
}
